import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface IUseMobileTopBottomColor {
  circadiaEngineProvider: ICircadiaEngineProvider;
}

export const useMobileTopBottomColor = ({
  circadiaEngineProvider,
}: IUseMobileTopBottomColor) => {
  const location = useLocation();
  useEffect(() => {
    // Function to update colors based on current hash
    const updateColors = () => {
      if (
        location.pathname.includes("get-started") ||
        location.pathname.includes("login") ||
        location.pathname.includes("otp") ||
        location.pathname.includes("otp-verification") ||
        location.pathname.includes("patient-profile") ||
        location.pathname.includes("notification-settings") ||
        location.pathname.includes("floor-settings")
      ) {
        circadiaEngineProvider.changeAppTopAndBottom("#fcfbfa", "#fcfbfa");
      } else if (
        location.pathname.includes("flag/chime") ||
        location.pathname.includes("bed-exit/chime") ||
        location.pathname.includes("escalation/chime")
      ) {
        circadiaEngineProvider.changeAppTopAndBottom("#161646", "#161646");
      } else if (location.pathname.includes("alert-details")) {
        circadiaEngineProvider.changeAppTopAndBottom("#fcfbfa", "#ffffff");
      } else {
        circadiaEngineProvider.changeAppTopAndBottom("#ffffff", "#ffffff");
      }
    };
    updateColors();
  }, [location.pathname]);

  return null;
};
